import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import {Tooltip, Icon, Badge} from 'antd';
import ProgressForTable from './ProgressForTable.js';
import Loading from '../../commons/Loading.js';
import ToolBar from '../../commons/ToolBar.js';

class SystemUsageContainerList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ctData: this.props.ctData,
            loading: this.props.loading
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            ctData: nextProps.ctData,
            loading: nextProps.loading
        });
    }

    progressCPUFormat = (cell, row, enumObject, rowIndex) => {
        return (
            <div>
                <ProgressForTable percent={cell} level={row.cpuLevel}/>
            </div>
        );
    }

    progressMemoryFormat = (cell, row, enumObject, rowIndex) => {
        return (
            <div>
                <ProgressForTable percent={cell} level={row.memoryLevel}/>
            </div>
        );
    }

    alertCountFormatter = (cell, row, enumObject, rowIndex) => {
        const listItems = row.alert.map((item) =>
            <small key={item}>{item}</small>
        );
        const tips = (<div style={{display: 'grid'}}>{listItems}</div>);

        return (
            <div>
                <div style={{textAlign: 'center', color: '#D11C23', display: cell > 0 ? 'block' : 'none'}}>
                    <Tooltip title={tips}>
                        {cell}
                    </Tooltip>
                </div>
                <div style={{textAlign: 'center', display: cell > 0 ? 'none' : 'block'}}>
                    {cell}
                </div>
            </div>
        )
    }

    serviceStatusFormatter = (cell, row, enumObject, rowIndex) => {
        return (
            <div style={{textAlign: 'center'}}>
                <Badge status={row.serviceStatus === 'passing' ? 'success' : 'error'}/>
            </div>
        )
    }

    serviceNameFormatter = (cell, row, enumObject, rowIndex) => {
        const tp = (
            <Tooltip title="Container Type">
                <Icon type="question-circle-o"/>
            </Tooltip>
        );
        const showServiceName = row.serviceName === '' ? row.containerType : row.serviceName;
        const tips = row.serviceName === '' ? tp : '';
        return (
            <div>
                {showServiceName} {tips}
            </div>
        )
    }

    serviceNameSearch = (cell, row, enumObject, rowIndex) => {
        return row.serviceName === '' ? row.containerType : row.serviceName;
    }

    sortServiceName = (a, b, order) => {
        const aValue = (a.serviceName === '' ? a.containerType : a.serviceName).toLowerCase();
        const bValue = (b.serviceName === '' ? b.containerType : b.serviceName).toLowerCase();
        if (order === 'desc') {
            if (aValue > bValue) {
                return -1;
            } else if (aValue < bValue) {
                return 1;
            } else {
                return 0
            }
        } else {
            if (aValue < bValue) {
                return -1;
            } else if (aValue > bValue) {
                return 1;
            } else {
                return 0
            }
        }
    }

    createCustomToolBar = props => {
        return (
            <div>
                <div className='buttonFiled'>
                    <ToolBar onFresh={this.props.onFresh}/>
                </div>
                <div className='searchFiled'>
                    { props.components.searchPanel }
                </div>
            </div>
        );
    }

    render() {
        const ctData = this.state.ctData;

        const options = {
            defaultSortName: 'serviceName',
            defaultSortOrder: 'asc',
            toolBar: this.createCustomToolBar,
            searchDelayTime: 500,
            noDataText: this.state.loading ? <Loading /> : 'No container found.'
        };
        return (
            <BootstrapTable data={ ctData } search={ true } options={ options } striped hover condensed>
                <TableHeaderColumn dataField='serviceStatus' dataSort={ true }
                                   dataFormat={this.serviceStatusFormatter} width="5%">Status</TableHeaderColumn>
                <TableHeaderColumn dataField='serviceName' dataFormat={this.serviceNameFormatter}
                                   dataSort={ true } searchable={ false }
                                   sortFunc={this.sortServiceName} width="22%">Service Name</TableHeaderColumn>
                <TableHeaderColumn dataField='serviceName' dataFormat={this.serviceNameSearch}
                                   filterFormatted={ true } hidden={ true }/>
                <TableHeaderColumn dataField='hostName' dataSort={ true } width="18%">Host Name</TableHeaderColumn>
                <TableHeaderColumn dataField='alertCount' dataSort={ true }
                                   dataFormat={this.alertCountFormatter} width="7%">Alerts</TableHeaderColumn>
                <TableHeaderColumn dataField='cpu' dataSort={ true }
                                   dataFormat={ this.progressCPUFormat } width="14%">CPU</TableHeaderColumn>
                <TableHeaderColumn dataField='memory' dataSort={ true }
                                   dataFormat={ this.progressMemoryFormat } width="14%">Memory</TableHeaderColumn>
                <TableHeaderColumn dataField='containerID' isKey dataSort={ true }
                                   width="20%" columnTitle>Container ID</TableHeaderColumn>
            </BootstrapTable>
        );
    }
}

export default SystemUsageContainerList;


// WEBPACK FOOTER //
// ./src/modules/system-usage/SystemUsageContainerList.js